import * as React from 'react';
import { WithGroup, WithGroupProps } from '../Context';
import { AddMembersIcon } from '../../icons/AddMembersIcon';
import { canInviteMembers } from '@wix/social-groups-api';
import styles from './InviteMembers.st.css';
import { AddMembersModal } from '../modals/AddMemberModal/AddMembersModal';
import { WebOut } from '@wix/social-groups-common';
import { compose } from '@wix/social-groups-common/dist/src/compose';
import {
  MemberInvites,
  withMemberInvites,
  withBiLogger,
  WithBiLoggerProps,
  tryToCallBi,
} from '@wix/social-groups-common/dist/src/context';
import {
  withTpaComponentsConfig,
  WithTpaComponentsConfigProps,
} from '../Context/withTpaComponentsConfig';
import { InjectedTranslateProps, translate } from 'react-i18next';

export const INVITE_MEMBERS = 'invite-members';

interface InviteMembersProps {}

interface InviteMembersState {
  isModalOpen: boolean;
}

export class InviteMembersComponent extends React.Component<
  InviteMembersProps &
    WithGroupProps &
    WithTpaComponentsConfigProps &
    MemberInvites &
    InjectedTranslateProps &
    WithBiLoggerProps,
  InviteMembersState
> {
  readonly state: InviteMembersState = {
    isModalOpen: false,
  };
  private readonly onCloseModal = () => {
    this.setState({ isModalOpen: false });
  };
  private readonly openModal = () => {
    tryToCallBi(async () => {
      await this.props.biLogger.groupsAddMemberClicked({
        groupId: this.props.group.groupId,
        origin: 'group_member_icon_btn',
      });
    });
    this.setState({ isModalOpen: true });
  };

  render() {
    const { group, currentMember, mobile, memberInvitesLink, t } = this.props;
    const canAddMembers = canInviteMembers(group);
    if (!canAddMembers) {
      return null;
    }

    const { isModalOpen } = this.state;
    return (
      <div {...styles('root', { mobile })}>
        <button
          data-hook={INVITE_MEMBERS}
          onClick={this.openModal}
          className={styles.button}
        >
          <AddMembersIcon width="20px" height="20px" />
        </button>
        <div className={styles.gap} />
        {mobile ? (
          <WebOut
            inviteLink={memberInvitesLink}
            buttonLabelKey={t('groups-web.web-out.button')}
            title={t('groups-web.web-out.invite-members.title')}
            caption={t('groups-web.web-out.invite-members.description')}
            isOpen={isModalOpen}
            onRequestClose={this.onCloseModal}
          />
        ) : (
          <AddMembersModal
            group={group}
            isOpen={isModalOpen}
            handleClose={this.onCloseModal}
            currentMember={currentMember}
          />
        )}
      </div>
    );
  }
}
const enhance = compose(
  WithGroup,
  withTpaComponentsConfig,
  withMemberInvites,
  withBiLogger,
  translate(),
);
export const InviteMembers = enhance(
  InviteMembersComponent,
) as React.ComponentType<InviteMembersProps>;
